import { getStoreId } from "$/hooks/use-store-information"
import supportChatQueries from "$/lib/queries/support-chat-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/support-chat")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId) queryClient.prefetchQuery(supportChatQueries.messages(storeId))
    return { crumb: "alfred.pages.supportChat.crumbs.supportChat" }
  },
})
